// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hSsdi","label":"styles_label__2xpCa"};